import { ATTACHMENT_TYPES, VIMEO_VIDEO_STATUS } from '../utils/constants';

export function classDiarySave(values, files, filesAlreadyToUploaded) {
  const classSequence = values.classSequence.map((sequence) => sequence.value);
  let filesId;
  if (files) {
    filesId = files.map((file) =>
      file.uploadType === ATTACHMENT_TYPES.VIMEO
        ? {
            fileId: null,
            fileUrl: file.fileId,
            order: 0,
            id: 0,
            fileType: file.uploadType,
            status: file.status ? file.status : VIMEO_VIDEO_STATUS.IN_PROGRESS,
          }
        : {
            fileId: file.fileId,
            order: 0,
            id: 0,
            fileType: file.uploadType,
          }
    );
  }
  if (files && filesAlreadyToUploaded) {
    const filesAlready = filesAlreadyToUploaded.map((file) => {
      if (file.fileType === ATTACHMENT_TYPES.VIMEO) {
        return {
          fileId: null,
          fileUrl: file.fileUrl,
          order: 0,
          id: 0,
          fileType: file.fileType,
          status: file.status ? file.status : VIMEO_VIDEO_STATUS.IN_PROGRESS,
        };
      }
      return {
        fileId: file.fileId,
        order: 0,
        id: 0,
        fileType: file.fileType,
      };
    });
    filesId = [...filesId, ...filesAlready];
  } else {
    filesId = [];
  }

  const mutation = `mutation ($workSubject: String!, $description: String!){ 
        classDiarySave(
            classDiary: 
                {
                    id: ${values.id ? values.id : 0},
                    cycle: ${values.cycle ? values.cycle : 0}
                    dateInMilli: ${new Date(values.dateInMilli).getTime()}
                    classSequence:${JSON.stringify(classSequence).replace(
                      /"([^(")"]+)":/g,
                      '$1:'
                    )},
                    workSubject: $workSubject,
                    description: $description,
                    schoolClass: {
                        id: ${values.schoolClass.id},
                        active: true,
                        year: 0,
                        studentsQuantity: 0,
                        filterByStatus: false,
                        updaterId: 0,
                        capacity: 0
                    },
                    subject: {
                        id: ${values.subject.id},
                        active: true,
                        termFilterId: 0,
                        subjectLevelFilterId: 0,
                        filterByStatus: false,
                        updaterId: 0
                    },
                    shift: {
                        id: ${
                          values.schoolClass.classShift.id
                            ? values.schoolClass.classShift.id
                            : null
                        },
                        active: true,
                        filterByStatus: false,
                        updaterId:0
                    }
                    files: ${JSON.stringify(filesId).replace(
                      /"([^(")"]+)":/g,
                      '$1:'
                    )}
                }
        ), {id}
      }`;
  return mutation;
}

export function classDiaryListBySmartFilter(filter) {
  const query = `{
        classDiaryListBySmartFilter(filter: ${JSON.stringify(filter).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )}) 
        {
            id,
            cycle,
            dateInMilli,
            classSequence,
            workSubject,
            description,
            schoolClass {
                id,
                name,
                value,
                label            
            },
            subject {
                id, 
                name,
                value,
                label
            },
            shift {
                id, 
                name,
                value,
                label
            }
        }
    }`;
  return query;
}

export default function classDiaryListBySmartFilterById(id) {
  return `{
  classDiaryListBySmartFilter(filter: { id: ${id} }) {
            id
            cycle
            dateInMilli
            classSequence
            workSubject
            description
            schoolClass {
                id
                name
                value
                label 
                courseStep {
                  id
                  label
                  value
                  cycleQuantity
                  course {
                    id
                  }
                }
                classShift {
                  id
                }
                academicCalendar { id }           
            }
            subject {
                id 
                name
                value
                label
            }
            shift {
                id 
                name
                value
                label
            }
            files {
                fileId
                fileUrl
                fileName
                fileType
                fileId
                fileUrl
                thumbFileId
                thumbFileUrl
                order
                status
            },
        }
}`;
}
